import React from 'react';
import LibraryPage from '../components/library/LibraryPage';

/** The school's standard operating procedures, for staff to read and download. */
const SOPPage: React.FC = () => (
  <LibraryPage config={{
    kind: 'sops',
    module: 'sops',
    title: 'Standard Operating Procedures',
    subtitle: 'How the school does things, step by step — for staff to read and download.',
    noun: 'SOP',
    plural: 'SOPs',
  }} />
);

export default SOPPage;
